let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("emmgV")).then(() => parcelRequire('MHp0n'));